import React from 'react'
import { twMerge } from 'tailwind-merge'

export type InfoPageSectionProps = {
  prependTitle?: string
  title?: string
  appendTitle?: string
  staggerTitleAppend?: boolean
  subTitle?: React.ReactNode
  text?: React.ReactNode
  children?: React.ReactNode
  className?: string
  containerClasses?: string
}

// Use forwardRef to allow a parent component to pass a ref
export const InfoPageSection = React.forwardRef<
  HTMLDivElement,
  InfoPageSectionProps
>(
  (
    {
      title,
      prependTitle,
      appendTitle,
      text,
      subTitle,
      children,
      className,
      staggerTitleAppend,
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={twMerge('flex justify-center', className)}>
        <div className='grow flex flex-col max-w-3xl py-16 px-4'>
          {/* <AnimateEntrance  transition='fade'>
          <h1 className='text-4xl text-center font-extrabold text-base-900 sm:text-6xl'>
            {title}
          </h1>
        </AnimateEntrance> */}
          <h1 className='text-4xl self-center items-center font-extrabold text-base-900 max-sm:gap-2 sm:text-6xl flex flex-col'>
            {prependTitle && (
              <span
                className={twMerge(
                  'text-2xl text-base-500',
                  staggerTitleAppend && 'sm:self-start',
                )}>
                {prependTitle}
              </span>
            )}
            <div className='flex text-center md:text-left'>{title}</div>
            {appendTitle && (
              <span
                className={twMerge(
                  'text-2xl text-base-500',
                  staggerTitleAppend && 'sm:self-end',
                )}>
                {appendTitle}
              </span>
            )}
          </h1>

          {subTitle && (
            <div className='py-6 border-b mb-2 text-center text-xl font-semibold text-base-600'>
              {subTitle}
            </div>
          )}

          {text && (
            <div className='text-left py-4 text-lg leading-8 text-base-600'>
              {text}
            </div>
          )}

          {children && <div>{children}</div>}
        </div>
      </div>
    )
  },
)

// Add display name for debugging purposes
InfoPageSection.displayName = 'InfoPageSection'

export const TitlePageSection = (props: InfoPageSectionProps) => (
  <div className={twMerge('relative pt-8', props.className)}>
    <div
      className='absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80'
      aria-hidden='true'>
      <div
        className='relative left-[calc(50%-11rem)] aspect-1155/678 w-144.5 -translate-x-1/2 rotate-30 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-288.75'
        // className='relative left-[calc(50%-11rem)] aspect-1155/678 w-144.5 -translate-x-1/2 rotate-30 bg-linear-to-tr from-yellow-400 to-orange-700 opacity-30 sm:left-[calc(50%-30rem)] sm:w-288.75'
        style={{
          clipPath:
            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
        }}
      />
    </div>
    <div className='py-12 sm:py-16'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div
          className={twMerge(
            'mx-auto max-w-2xl text-center',
            props.containerClasses,
          )}>
          {props.title && (
            <h1 className='text-4xl font-extrabold tracking-tight text-base-900 sm:text-6xl'>
              {props.title}
            </h1>
          )}

          {props.subTitle && (
            <div className='py-6 border-b mb-2 text-center text-xl font-semibold text-base-600'>
              {props.subTitle}
            </div>
          )}
          <div className='mt-6 text-lg leading-8 text-base-600'>
            {props.text}
          </div>
          {props.children}
        </div>
      </div>
    </div>
    <div
      className='absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]'
      aria-hidden='true'>
      <div
        className='relative left-[calc(50%+3rem)] aspect-1155/678 w-144.5 -translate-x-1/2 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-288.75'
        // className='relative left-[calc(50%-11rem)] aspect-1155/678 w-144.5 -translate-x-1/2 rotate-30 bg-linear-to-tr from-yellow-400 to-orange-700 opacity-30 sm:left-[calc(50%-30rem)] sm:w-288.75'
        style={{
          clipPath:
            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
        }}
      />
    </div>
  </div>
)
